<template>
  <div
    ref="item"
    class="vt-video-background"
  >
    <video
      v-show="playing"
      :id="id"
      ref="video"
      preload="metadata"
      muted
      webkit-playsinline="true"
      playsinline="true"
      allow="autoplay"
      frameborder="0"
      loop
      @error="onError"
    >

      <source
        :src="videoUrl"
        type="video/mp4"
      >
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import {
  ref, onMounted, getCurrentInstance, watch
} from 'vue'

export default {
  name: 'VtVideoBackground',
  props: {
    videoUrl: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'video'
    },
    start: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const player = ref(null)
    const playing = ref(false)
    const played = ref(false)
    const error = ref(false)
    const loadedVideo = ref(false)
    let videoRatio = 0

    onMounted(() => {
      if (!props.videoUrl.length || error.value) {
        onError()
      }

      player.value = getCurrentInstance().refs.video
      player.value.muted = true

      player.value.addEventListener('error', onError)
      player.value.addEventListener('abort', onError)
      player.value.addEventListener('pause', () => {
        playing.value = false
      })
      window.addEventListener('resize', resizeVideo)
      player.value.oncanplay = () => {
        videoRatio = player.value.videoWidth / player.value.videoHeight
        resizeVideo()
        loadedVideo.value = true
      }
      player.value.onplaying = () => {
        playing.value = true
      }
      player.value.onpause = () => {
        player.value.play()
      }

      player.value.load()
    })

    const startWatcher = watch(() => props.start, (on) => {
      resizeVideo()

      if (on) {
        playing.value = true
        player.value.play()
      } else {
        playing.value = false
        player.value.load()
      }
    })

    const pause = () => {
      playing.value = false
      player.value.pause()
    }

    const onError = () => {
      playing.value = false
      error.value = true
    }

    const resizeVideo = () => {
      if (windowRatio() < videoRatio) {
        player.value.style.width = 'auto'
        player.value.style.height = '100%'
      } else {
        player.value.style.height = 'auto'
        player.value.style.width = '100%'
      }
    }

    const windowRatio = () => {
      return player.value.parentElement.offsetWidth / player.value.parentElement.offsetHeight
    }

    return {
      player,
      playing,
      played,
      error,
      loadedVideo,
      videoRatio,
      startWatcher,
      pause,
      onError,
      resizeVideo,
      windowRatio,
      emit
    }
  }
}

</script>
